class TextSalvagny {
	constructor() {
		this.text = document.querySelector(".text-salvagny");

		if (!this.text) {
			return;
		}

		this.buildText();
	}

	buildText() {
		const letters = this.text.querySelectorAll(".color");

		// On récupère 4 lettres en random
		const lineLength = 20;
		const lineMove = 50;
		const randLetters = Array.from(letters).sort(() => Math.random() - Math.random()).slice(0, 5);
		const fromStart = Math.floor(Math.random() * 100);
		const fromEnd = fromStart + lineLength;
		const toStart = fromStart + lineMove;
		const toEnd = toStart + lineLength;

		randLetters.forEach(letter => {
			letter.classList.add("active");
			gsap.fromTo(letter, {
				drawSVG: `${fromStart}% ${fromEnd}%`
			}, {
				drawSVG: `${toStart}% ${toEnd}%`,
				scrollTrigger: {
					trigger: this.text,
					start: 0,
					end: window.innerHeight * 2,
					scrub: 1
				}
			});
		});

	}
}